import React from 'react';
import { connect } from 'react-redux';
import { MqttConsumer } from 'helpers/mqtt/MqttProvider';
import moment from 'moment';
import UserManagementComponent from './UserManagementComponent';

import { changeLocation, loadLocations } from '../../actions/dashboard-actions';

import { userManagementOperations } from './duck';
import { appActions } from 'App/duck';
import { userManagementActions } from './duck';
import { appOperations } from 'App/duck';
import {unregisteredUserOperations} from '../UnregisteredUser/duck';

const mapStateToProps = ({
  locationReducer,
  appReducer,
  userManagementReducer,
  unregisteredUserReducer,
}) => {
  return {
    locationSettings: appReducer.location.settings,
    locationId: locationReducer.location_code,
    locationData: locationReducer.location_data,
    locations: locationReducer.locations,
    managers: appReducer.managers.users,
    associates: appReducer.associates.users,
    allUsers: appReducer.allUsers.users,
    removedUsers: appReducer.removedUsers.users,
    pendingUsers: appReducer.pendingUsers.users,
    departments: appReducer.departments.data,
    channels: appReducer.channels.data,
    roles: appReducer.roles.data,

    unregisteredUsers: unregisteredUserReducer.unregisteredUsers.users,

    skills: appReducer.skills.data,
    channelMembers: appReducer.users.data,
    channelData: userManagementReducer.channelMembers.data,
    loadingAssociates: appReducer.associates.loading,
    loadingManagers: appReducer.managers.loading,
    loadingRemovedUsers: appReducer.removedUsers.loading,
    lastAction: appReducer.managers.lastAction,
    lastOperation: userManagementReducer.managers.lastOperation,
    error: userManagementReducer.allUsers.error,
    plans: appReducer.plans.data,
    locationData: locationReducer.location_data,
  };
};

const mapDispatchToProps = (dispatch) => {
  const fetchRemovedUsers = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchRemovedUsers(locationId, pageNo, numPerPage));
  };

  const loadLocationRolesDispatch = (locationId) => {
    dispatch(appOperations.fetchLocationRolesOperation(locationId));
  };

  const fetchAllUsers = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchAllUsers(locationId, pageNo, numPerPage));
  };
  const fetchUnregisteredUsers = (locationId) => {
    dispatch(unregisteredUserOperations.fetchUnregisteredUsersDispatch(locationId));
  };
  const handleRemoveUnregisteredUser = (unregisteredUserId) => {
    dispatch(unregisteredUserOperations.removeUnregisteredUserOperation(unregisteredUserId));
  }

  const getLocationInnerDepartments = (locationId) => {
    dispatch(userManagementOperations.getLocationInnerDepartments(locationId));
  };
  const getLocationUsableSkills = (locationId) => {
    dispatch(userManagementOperations.getLocationUsableSkills(locationId));
  };
  const requestChannelMembers = () => {
    dispatch(userManagementActions.requestChannelMembers(true));
  };
  const getLocationChannels = (locationId) => {
    dispatch(userManagementOperations.getLocationChannels(locationId));
  };
  const handlePromote = (userPrivileges) => {
    dispatch(userManagementOperations.updateAdminStatus(userPrivileges, true));
  };

  const handleWithdraw = (userPrivileges) => {
    dispatch(userManagementOperations.updateAdminStatus(userPrivileges, false));
  };

  const handleApprove = (userPrivilegeId, locationId) => {
    dispatch(userManagementOperations.approveUser(userPrivilegeId, locationId));
  };

  const handleDeny = (users, locationId) => {
    dispatch(userManagementOperations.denyUser(users, locationId));
  };

  const handleRemove = (admins, nonAdmins, locationId) => {
    dispatch(userManagementOperations.removeUser(admins,  nonAdmins, locationId));
  };

  const resetManagers = () => {
    dispatch(userManagementActions.resetManagers(true));
  };

  const resetAssociates = () => {
    dispatch(userManagementActions.resetAssociates(true));
  };

  const resetRemovedUsers = () => {
    dispatch(userManagementActions.resetRemovedUsers(true));
  };

  const resetPendingUsers = () => {
    dispatch(userManagementActions.resetPendingUsers(true));
  };

  const resetAllUsers = () => {
    dispatch(userManagementActions.resetAllUsers(true));
  };

  const handleCreateSkill = (skillName, locationId) => {
    dispatch(userManagementOperations.createSkill(skillName, locationId));
  }

  const handleCreateGroup = (groupName, locationId, description) => {
    dispatch(userManagementOperations.createGroup(groupName, locationId, description));
  };

  const handleCreateDepartment = (deptName, locationId, description) => {
    dispatch(userManagementOperations.createDepartment(deptName, locationId, description));
  };

  const handleAddUserToGroup = (channelId, users) => {
    dispatch(userManagementOperations.addUserToGroup(channelId, users));
  };

  const handleRemoveUserFromGroup = (channelId, users, memberCount) => {
    dispatch(userManagementOperations.removeUserFromGroup(channelId, users, memberCount));
  };

  const handleAddUserToDepartment = (users, departmentId) => {
    dispatch(userManagementOperations.addUserToDepartment(users, departmentId));
  };

  const handleRemoveUserFromDepartment = (users, departmentId) => {
    dispatch(userManagementOperations.removeUserFromDepartment(users, departmentId));
  };

  const handleAssignUsersToSkill = (users, locationId, skill) => {
    dispatch(userManagementOperations.assignUsersToSkill(users, locationId, skill));
  };

  const handleRemoveUsersFromSkill = (users, locationId, skill) => {
    dispatch(userManagementOperations.removeUsersFromSkill(users, locationId, skill));
  };

  const handleChangeLocation = (locationId) => {
    dispatch(changeLocation(locationId));
  };

  const handleGetUserInformation = (userPrivilege, locationId) => {
    dispatch(userManagementOperations.getUserInformation1(userPrivilege, locationId));
  };

  const resetChannels = () => {
    dispatch(appActions.resetChannels(true));
  };

   const fetchSubscriptions = (channel_id) => {
    dispatch(userManagementOperations.fetchSubscriptions(channel_id));
  };
  
  return { 
    fetchRemovedUsers,
    fetchAllUsers,
    fetchUnregisteredUsers,
    handleRemoveUnregisteredUser,
    getLocationInnerDepartments,
    getLocationUsableSkills,
    requestChannelMembers,
    fetchSubscriptions,
    getLocationChannels,
    handlePromote,
    handleWithdraw,
    handleApprove,
    handleDeny,
    handleRemove,
    resetManagers,
    resetAssociates,
    resetRemovedUsers,
    resetPendingUsers,
    resetAllUsers,
    handleCreateSkill,
    handleCreateGroup,
    handleCreateDepartment,
    handleAddUserToGroup,
    handleRemoveUserFromGroup,
    handleAddUserToDepartment,
    handleRemoveUserFromDepartment,
    handleAssignUsersToSkill,
    handleRemoveUsersFromSkill,
    handleChangeLocation,
    handleGetUserInformation,
    resetChannels,
    loadLocationRolesDispatch,
  };
};

const UserManagementContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  return (
    <MqttConsumer>
      {(client) => {
        const { 
                locationSettings,
                locationId,
                locationData,
                locations,
                managers,
                associates,
                removedUsers,
                allUsers,
                pendingUsers,
                departments,
                channels,
                roles,
                skills,
                channelMembers,
                channelData,
                loadingAssociates,
                loadingManagers,
                loadingRemovedUsers,
                loadingChannelMembers,
                lastAction,
                lastOperation,
                error,
                plans,
                unregisteredUsers,

                fetchRemovedUsers,
                fetchAllUsers,
                fetchUnregisteredUsers,
                handleRemoveUnregisteredUser,
                getLocationInnerDepartments,
                getLocationUsableSkills,
                requestChannelMembers,
                fetchSubscriptions,
                getLocationChannels,
                handlePromote,
                handleWithdraw,
                handleApprove,
                handleDeny,
                handleRemove,
                resetManagers,
                resetAssociates,
                resetRemovedUsers,
                resetPendingUsers,
                resetAllUsers,
                handleCreateSkill,
                handleCreateGroup,
                handleCreateDepartment,
                handleAddUserToGroup,
                handleRemoveUserFromGroup,
                handleAddUserToDepartment,
                handleRemoveUserFromDepartment,
                handleAssignUsersToSkill,
                handleRemoveUsersFromSkill,
                handleChangeLocation,
                handleGetUserInformation,
                resetChannels,
                loadLocationRolesDispatch,
              } = props;

        return (
          <UserManagementComponent
            mqttClient={client}
            locationSettings={locationSettings}
            locationId={locationId}
            locationData={locationData}
            locations={locations}
            managers={managers}
            associates={associates}
            removedUsers={removedUsers}
            pendingUsers={pendingUsers}
            allUsers={allUsers}
            departments={departments}
            channels={channels}
            roles={roles}
            skills={skills}
            channelMembers={channelMembers}
            channelData={channelData}
            loadingAssociates={loadingAssociates}
            loadingManagers={loadingManagers}
            loadingRemovedUsers={loadingRemovedUsers}
            loadingChannelMembers={loadingChannelMembers}
            lastAction={lastAction}
            lastOperation={lastOperation}
            error={error}

            fetchRemovedUsers={fetchRemovedUsers}
            fetchAllUsers={fetchAllUsers}
            fetchUnregisteredUsers = {fetchUnregisteredUsers}
            handleRemoveUnregisteredUser = {handleRemoveUnregisteredUser}
            getLocationInnerDepartments={getLocationInnerDepartments}
            getLocationUsableSkills={getLocationUsableSkills}
            requestChannelMembers={requestChannelMembers}
            fetchSubscriptions={fetchSubscriptions}
            getLocationChannels={getLocationChannels}
            handlePromote={handlePromote}
            handleWithdraw={handleWithdraw}
            handleApprove={handleApprove}
            handleDeny={handleDeny}
            handleRemove={handleRemove}
            resetManagers={resetManagers}
            resetAssociates={resetAssociates}
            resetRemovedUsers={resetRemovedUsers}
            resetPendingUsers={resetPendingUsers}
            resetAllUsers={resetAllUsers}
            handleCreateSkill={handleCreateSkill}
            handleCreateGroup={handleCreateGroup}
            handleCreateDepartment={handleCreateDepartment}
            handleAddUserToGroup={handleAddUserToGroup}
            handleRemoveUserFromGroup={handleRemoveUserFromGroup}
            handleAddUserToDepartment={handleAddUserToDepartment}
            handleRemoveUserFromDepartment={handleRemoveUserFromDepartment}
            handleAssignUsersToSkill={handleAssignUsersToSkill}
            handleRemoveUsersFromSkill={handleRemoveUsersFromSkill}
            handleChangeLocation={handleChangeLocation}
            handleGetUserInformation={handleGetUserInformation}
            resetChannels={resetChannels}
            plans={plans}

            unregisteredUsers={unregisteredUsers}
            loadLocationRolesDispatch={loadLocationRolesDispatch}
          />
        );
      }}
    </MqttConsumer>
  );
});

export default UserManagementContainer;
